export class TopCommodity {
  commodityName = "";
  bookingAtPos = 0;
  bookingDestinationCity = 0;
  rank = 0;
  lastSyncAt = "";

  constructor(fields?: Partial<TopCommodity>) {
    Object.assign(this, fields);
  }
}

export class TopCommodityResponse {
  lastSyncAt = "";
  cityCode = "";
  data: TopCommodity[] = [];

  constructor(fields?: Partial<TopCommodityResponse>) {
    Object.assign(this, fields);

    if (fields?.data) {
      this.data = fields.data.map((item: TopCommodity) => new TopCommodity(item));
    }
  }
}